/* Aurum — JavaScript del tema (sin dependencias) */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const theme = window.theme || {};

  /* ---------- Utilidades ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '${{amount}}';
    const value = Number(cents) / 100;
    const fmt = (n, dec, thou, decSep) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decSep);
    };
    const m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    let out;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = fmt(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = fmt(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fmt(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = fmt(value, 2, "'", '.'); break;
      default: out = fmt(value, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }
  theme.formatMoney = formatMoney;

  function toast(msg) {
    const el = $('.toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.hidden = true; }, 3200);
  }

  function lockScroll(lock) { document.body.classList.toggle('no-scroll', lock); }

  /* ---------- Drawers (menú, carrito) ---------- */
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    const f = d.querySelector('[data-drawer-close]');
    if (f) setTimeout(() => f.focus(), 50);
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) lockScroll(false);
  }
  theme.openDrawer = openDrawer;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (opener.dataset.drawerOpen === 'CartDrawer' && theme.cartType !== 'drawer') return;
      e.preventDefault();
      openDrawer(opener.dataset.drawerOpen);
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    const sm = $('.search-modal.is-open');
    if (sm) closeSearch(sm);
  });

  /* ---------- Header que se oculta al bajar ---------- */
  const header = $('.header-wrapper[data-hide-on-scroll]');
  if (header) {
    let last = window.scrollY;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('is-hidden', y > last && y > 200);
      last = y;
    }, { passive: true });
  }

  /* ---------- Buscador predictivo ---------- */
  function closeSearch(m) { m.classList.remove('is-open'); lockScroll(false); }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-search-open]');
    if (t) {
      const m = $('.search-modal');
      if (!m) return;
      e.preventDefault();
      m.classList.add('is-open');
      lockScroll(true);
      setTimeout(() => { const i = m.querySelector('input[type="search"]'); if (i) i.focus(); }, 50);
      return;
    }
    const m = e.target.closest('.search-modal');
    if (m && (e.target === m || e.target.closest('[data-search-close]'))) closeSearch(m);
  });
  $$('[data-predictive-input]').forEach((input) => {
    const results = input.closest('form').parentElement.querySelector('[data-predictive-results]');
    let timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        try {
          const url = `${theme.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;
          const html = await (await fetch(url)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('[data-predictive-inner]');
          results.innerHTML = inner ? inner.innerHTML : '';
        } catch (err) { results.innerHTML = ''; }
      }, 250);
    });
  });

  /* ---------- Animaciones al hacer scroll ---------- */
  if ('IntersectionObserver' in window && document.body.classList.contains('has-animations')) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    const observe = (root) => $$('.reveal:not(.is-visible)', root).forEach((el) => io.observe(el));
    observe(document);
    document.addEventListener('shopify:section:load', (e) => observe(e.target));
  } else {
    $$('.reveal').forEach((el) => el.classList.add('is-visible'));
  }

  /* ---------- Rotación genérica (anuncios / slideshow) ---------- */
  class Rotator extends HTMLElement {
    connectedCallback() {
      this.slides = $$('[data-slide]', this);
      this.dots = $$('[data-dot]', this);
      this.i = 0;
      this.delay = (Number(this.dataset.speed) || 5) * 1000;
      if (this.slides.length < 2) return;
      this.dots.forEach((d, n) => d.addEventListener('click', () => { this.go(n); this.restart(); }));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      let x0 = null;
      this.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { this.go(this.i + (dx < 0 ? 1 : -1)); this.restart(); }
        x0 = null;
      });
      if (this.dataset.autoplay !== 'false') this.start();
    }
    disconnectedCallback() { this.stop(); }
    go(n) {
      this.i = (n + this.slides.length) % this.slides.length;
      this.slides.forEach((s, k) => s.classList.toggle('is-active', k === this.i));
      this.dots.forEach((d, k) => { d.classList.toggle('is-active', k === this.i); d.setAttribute('aria-current', k === this.i); });
    }
    start() { if (this.dataset.autoplay === 'false') return; this.stop(); this.t = setInterval(() => this.go(this.i + 1), this.delay); }
    stop() { clearInterval(this.t); }
    restart() { this.stop(); this.start(); }
  }
  customElements.define('rotator-el', Rotator);

  /* ---------- Cuenta regresiva ---------- */
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      const end = this.dataset.end ? new Date(this.dataset.end.trim().replace(' ', 'T')).getTime() : NaN;
      // Solo cuentas regresivas reales: sin fecha de fin, no se muestra.
      if (isNaN(end)) { this.hidden = true; return; }
      this.end = end;
      this.tick(); this.t = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.t); }
    tick() {
      const diff = Math.max(0, this.end - Date.now());
      if (diff === 0) {
        clearInterval(this.t);
        const s = this.closest('[data-countdown-wrapper]');
        if (s) s.hidden = true; else this.hidden = true;
      }
      const parts = { d: Math.floor(diff / 86400000), h: Math.floor(diff / 3600000) % 24, m: Math.floor(diff / 60000) % 60, s: Math.floor(diff / 1000) % 60 };
      const pad = (n) => String(n).padStart(2, '0');
      $$('[data-unit]', this).forEach((el) => { el.textContent = pad(parts[el.dataset.unit]); });
      const inline = $('[data-inline]', this);
      if (inline) inline.textContent = (parts.d ? parts.d + 'd ' : '') + `${pad(parts.h)}:${pad(parts.m)}:${pad(parts.s)}`;
    }
  }
  customElements.define('countdown-timer', CountdownTimer);

  /* ---------- Fechas de entrega estimada ---------- */
  class DeliveryDates extends HTMLElement {
    connectedCallback() {
      const days = (this.dataset.days || '').split(',').map((s) => s.trim());
      const months = (this.dataset.months || '').split(',').map((s) => s.trim());
      const skipWeekends = this.dataset.skipWeekends === 'true';
      const add = (date, n) => {
        const d = new Date(date);
        let added = 0;
        while (added < n) {
          d.setDate(d.getDate() + 1);
          if (skipWeekends && d.getDay() === 0) continue;
          added++;
        }
        return d;
      };
      const label = (d) => `${days[(d.getDay() + 6) % 7] || ''} ${d.getDate()} ${months[d.getMonth()] || ''}`.trim();
      const today = new Date();
      const a = add(today, Number(this.dataset.minDays || 1));
      const b = add(today, Number(this.dataset.maxDays || 3));
      $$('[data-date]', this).forEach((el) => {
        const k = el.dataset.date;
        el.textContent = k === 'today' ? label(today) : k === 'ready' ? label(a) : k === 'range' ? `${label(a)} – ${label(b)}` : label(b);
      });
    }
  }
  customElements.define('delivery-dates', DeliveryDates);

  /* ---------- Carrito ---------- */
  const Cart = {
    sections() {
      const ids = ['cart-drawer', 'cart-icon-bubble'];
      if ($('[data-main-cart]')) ids.push($('[data-main-cart]').dataset.sectionId);
      return ids;
    },
    async request(url, body) {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: this.sections().join(','), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || theme.strings.cartError);
      return data;
    },
    render(sections) {
      if (!sections) return;
      Object.entries(sections).forEach(([id, html]) => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (id === 'cart-drawer') {
          const target = $('#CartDrawerInner');
          const src = doc.querySelector('#CartDrawerInner');
          if (target && src) target.innerHTML = src.innerHTML;
        } else if (id === 'cart-icon-bubble') {
          const src = doc.querySelector('[data-cart-count]');
          $$('[data-cart-count]').forEach((el) => { if (src) { el.textContent = src.textContent; el.dataset.count = src.dataset.count; } });
        } else {
          const target = $('[data-main-cart]');
          const src = doc.querySelector('[data-main-cart]');
          if (target && src) target.innerHTML = src.innerHTML;
        }
      });
      document.dispatchEvent(new CustomEvent('cart:updated'));
    },
    async add(items, button) {
      if (button) { button.classList.add('is-loading'); button.disabled = true; }
      try {
        const data = await this.request(theme.routes.cart_add_url + '.js', { items });
        if (theme.cartType === 'page') { window.location.href = theme.routes.cart_url; return; }
        this.render(data.sections);
        openDrawer('CartDrawer');
      } catch (err) {
        toast(err.message);
      } finally {
        if (button) { button.classList.remove('is-loading'); button.disabled = false; }
      }
    },
    async change(line, quantity) {
      const drawer = $('#CartDrawer');
      if (drawer) drawer.classList.add('is-loading');
      try {
        const data = await this.request(theme.routes.cart_change_url + '.js', { line, quantity });
        this.render(data.sections);
      } catch (err) { toast(err.message); } finally { if (drawer) drawer.classList.remove('is-loading'); }
    }
  };
  theme.Cart = Cart;

  // Botones de cantidad / eliminar en carrito (lateral y página)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cart-qty]');
    if (btn) {
      e.preventDefault();
      const line = Number(btn.dataset.line);
      const input = btn.parentElement.querySelector('input');
      const q = Math.max(0, Number(input.value) + (btn.dataset.cartQty === 'plus' ? 1 : -1));
      input.value = q;
      Cart.change(line, q);
      return;
    }
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); Cart.change(Number(rm.dataset.line), 0); return; }
    const qa = e.target.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); Cart.add([{ id: Number(qa.dataset.quickAdd), quantity: 1 }], qa); }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-input]');
    if (input) Cart.change(Number(input.dataset.line), Math.max(0, Number(input.value)));
    const note = e.target.closest('[data-cart-note]');
    if (note) fetch(theme.routes.cart_update_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  });

  /* ---------- Formulario de producto ---------- */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = $('form[data-product-form]', this);
      this.idInput = $('input[name="id"]', this);
      this.qtyInput = $('input[name="quantity"]', this);
      const json = $('script[data-variants]', this);
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.sectionId = this.dataset.section;

      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-option]')) this.onOptionChange();
        if (e.target.matches('[data-bundle]')) this.onBundle(e.target);
      });
      $$('[data-qty-btn]', this).forEach((b) => b.addEventListener('click', () => {
        const v = Math.max(1, Number(this.qtyInput.value) + (b.dataset.qtyBtn === 'plus' ? 1 : -1));
        this.setQty(v, true);
      }));
      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));

      const checked = $('[data-bundle]:checked', this);
      if (checked) this.onBundle(checked);
      this.setupSticky();
    }

    selectedOptions() {
      return $$('[data-option-group]', this).map((g) => {
        const c = $('[data-option]:checked', g) || $('select[data-option]', g);
        return c ? c.value : null;
      });
    }

    onOptionChange() {
      const opts = this.selectedOptions();
      const v = this.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      $$('[data-option-group]', this).forEach((g, i) => {
        const lbl = $('[data-selected-value]', g);
        if (lbl) lbl.textContent = opts[i] || '';
      });
      this.updateAvailability(opts);
      this.setVariant(v);
    }

    updateAvailability(opts) {
      $$('[data-option-group]', this).forEach((g, idx) => {
        $$('input[data-option]', g).forEach((input) => {
          const test = opts.slice(); test[idx] = input.value;
          const ok = this.variants.some((x) => x.available && x.options.every((o, i) => i === idx ? o === input.value : (i > idx ? true : o === test[i])));
          input.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    setVariant(v) {
      this.variant = v;
      const btns = $$('[data-add-button]', document).filter((b) => b.dataset.section === this.sectionId);
      if (!v) {
        btns.forEach((b) => { b.disabled = true; $('.btn__label', b).textContent = theme.strings.unavailable; });
        return;
      }
      this.idInput.value = v.id;
      btns.forEach((b) => { b.disabled = !v.available; $('.btn__label', b).textContent = v.available ? (b.dataset.label || theme.strings.addToCart) : theme.strings.soldOut; });

      // precio
      $$(`[data-price-wrapper="${this.sectionId}"]`).forEach((w) => {
        const onSale = v.compare_at_price > v.price;
        w.classList.toggle('price--sale', onSale);
        const cur = $('[data-price]', w), cmp = $('[data-compare]', w), save = $('[data-save]', w);
        if (cur) cur.textContent = formatMoney(v.price);
        if (cmp) { cmp.textContent = onSale ? formatMoney(v.compare_at_price) : ''; cmp.hidden = !onSale; }
        if (save) {
          const pct = onSale ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
          save.hidden = !onSale;
          save.textContent = (save.dataset.template || '-[percent]%').replace('[percent]', pct).replace('[amount]', formatMoney(v.compare_at_price - v.price));
        }
      });

      // stock bajo
      const stock = $('[data-stock]', this);
      if (stock) stock.dispatchEvent(new CustomEvent('variant:change', { detail: v }));

      // imagen
      if (v.featured_media) {
        const gallery = document.querySelector(`[data-gallery="${this.sectionId}"]`);
        if (gallery && gallery.goToMedia) gallery.goToMedia(v.featured_media.id);
      }

      // packs: recalcular precios
      this.refreshBundles();

      // URL
      if (this.dataset.updateUrl !== 'false') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      const sticky = $('[data-sticky-price]');
      if (sticky) sticky.textContent = formatMoney(v.price);
    }

    refreshBundles() {
      const v = this.variant || this.variants.find((x) => String(x.id) === String(this.idInput.value));
      if (!v) return;
      $$('[data-bundle]', this).forEach((input) => {
        const q = Number(input.value), off = Number(input.dataset.discount || 0);
        const full = v.price * q, base = Math.max(v.compare_at_price || 0, v.price) * q;
        const price = Math.round(full * (100 - off) / 100);
        const wrap = input.closest('.bundle');
        const p = $('[data-bundle-price]', wrap), c = $('[data-bundle-compare]', wrap);
        if (p) p.textContent = formatMoney(price);
        if (c) { c.textContent = base > price ? formatMoney(base) : ''; }
      });
    }

    onBundle(input) {
      this.setQty(Number(input.value), false);
      this.refreshBundles();
    }

    setQty(v, fromStepper) {
      if (this.qtyInput) this.qtyInput.value = v;
      if (fromStepper) $$('[data-bundle]', this).forEach((b) => { b.checked = Number(b.value) === v; });
    }

    async onSubmit(e) {
      if (theme.cartType === 'page' && !this.dataset.ajax) return;
      e.preventDefault();
      const btn = e.submitter && e.submitter.matches('[data-add-button]') ? e.submitter : $('[data-add-button]', this);
      const items = [{ id: Number(this.idInput.value), quantity: Number(this.qtyInput ? this.qtyInput.value : 1) }];
      const fd = new FormData(this.form);
      const props = {};
      for (const [k, val] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && val) props[m[1]] = val; }
      if (Object.keys(props).length) items[0].properties = props;
      await Cart.add(items, btn);
    }

    setupSticky() {
      const bar = document.getElementById(`StickyAtc-${this.sectionId}`);
      const anchor = $('[data-add-button]', this);
      if (!bar || !anchor) return;
      document.body.classList.add('has-sticky-atc-ready');
      const io = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-sticky-atc', show);
      });
      io.observe(anchor);
      $('[data-sticky-add]', bar).addEventListener('click', (e) => {
        e.preventDefault();
        if (this.form.requestSubmit) this.form.requestSubmit(anchor); else anchor.click();
      });
    }
  }
  customElements.define('product-form', ProductForm);

  /* ---------- Stock bajo ---------- */
  class StockIndicator extends HTMLElement {
    connectedCallback() {
      this.addEventListener('variant:change', (e) => this.update(e.detail));
      this.threshold = Number(this.dataset.threshold || 10);
    }
    update(v) {
      const qty = v.inventory_quantity;
      const managed = v.inventory_management === 'shopify';
      const low = managed && v.available && qty > 0 && qty <= this.threshold;
      this.classList.toggle('stock--low', !!low);
      const txt = $('[data-stock-text]', this);
      if (!txt) return;
      if (!v.available) txt.textContent = this.dataset.soldout;
      else if (low) txt.textContent = this.dataset.low.replace('[count]', qty);
      else txt.textContent = this.dataset.in;
      const bar = $('[data-stock-bar]', this);
      if (bar) bar.style.width = low ? Math.max(8, qty / this.threshold * 100) + '%' : '100%';
    }
  }
  customElements.define('stock-indicator', StockIndicator);

  /* ---------- Galería de producto ---------- */
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-gallery-track]', this);
      this.slides = $$('[data-media-id]', this.track);
      this.thumbs = $$('[data-thumb]', this);
      this.counter = $('[data-gallery-counter]', this);
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
      const prev = $('[data-gallery-prev]', this), next = $('[data-gallery-next]', this);
      if (prev) prev.addEventListener('click', () => this.go(this.index() - 1));
      if (next) next.addEventListener('click', () => this.go(this.index() + 1));
      this.track.addEventListener('scroll', () => {
        clearTimeout(this._s);
        this._s = setTimeout(() => this.mark(this.index()), 60);
      }, { passive: true });
      this.mark(0);
    }
    index() { return Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth)); }
    go(i) {
      i = (i + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
      this.mark(i);
    }
    mark(i) {
      this.thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      const t = this.thumbs[i];
      if (t) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      if (this.counter) this.counter.textContent = `${i + 1} / ${this.slides.length}`;
    }
    goToMedia(id) {
      const i = this.slides.findIndex((s) => String(s.dataset.mediaId) === String(id));
      if (i >= 0) this.go(i);
    }
  }
  customElements.define('product-gallery', ProductGallery);

  /* ---------- Productos relacionados ---------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const io = new IntersectionObserver(async ([en]) => {
        if (!en.isIntersecting) return;
        io.disconnect();
        try {
          const html = await (await fetch(this.dataset.url)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('product-recommendations');
          if (inner && inner.innerHTML.trim()) this.innerHTML = inner.innerHTML;
          else this.closest('.section')?.setAttribute('hidden', '');
          $$('.reveal', this).forEach((el) => el.classList.add('is-visible'));
        } catch (err) { /* sin recomendaciones */ }
      }, { rootMargin: '0px 0px 300px 0px' });
      io.observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  /* ---------- Notificación de compras ---------- */
  class SalesPop extends HTMLElement {
    connectedCallback() {
      const raw = (this.dataset.entries || '').split(/<br\s*\/?>/i).map((s) => s.trim()).filter(Boolean);
      if (!raw.length || sessionStorage.getItem('salesPopClosed')) return;
      this.hidden = false;
      this.items = raw; this.i = 0;
      const every = (Number(this.dataset.interval) || 25) * 1000;
      $('.sales-pop__close', this).addEventListener('click', () => { this.classList.remove('is-visible'); clearInterval(this.t); try { sessionStorage.setItem('salesPopClosed', '1'); } catch (e) {} });
      setTimeout(() => this.show(), 6000);
      this.t = setInterval(() => this.show(), every);
    }
    show() {
      const parts = this.items[this.i % this.items.length].split(',').map((s) => s.trim());
      this.i++;
      const [name, city, prod] = parts;
      $('.sales-pop__text', this).innerHTML = `<strong>${name || ''}</strong>${city ? ' de ' + city : ''} compró<br>${prod || ''}`;
      this.classList.add('is-visible');
      setTimeout(() => this.classList.remove('is-visible'), 5500);
    }
  }
  customElements.define('sales-pop', SalesPop);

  /* ---------- Filtros de colección (envío automático) ---------- */
  document.addEventListener('change', (e) => {
    const f = e.target.closest('form[data-auto-submit]');
    if (f && !e.target.matches('[data-no-auto]')) f.submit();
  });
})();
